import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { getIoFlightRanges, getIoLineItemMarkers } from './datePicker.helpers';

import type { InsertionOrderFlight } from 'sonata-static-storage/lib/schemas/multiFlight/insertionOrderFlight.schema';
import type { LineItemSchedule } from '@/components/ioSettings/InsertionOrderForm/hooks/useIoLineItemSchedules';

const NO_FLIGHTS: InsertionOrderFlight[] = [];

/** IO flights (painted, not blocking) and the IO's line items, this one with its live dates, for the LI picker. */
export function useLineItemPickerSchedules(
  ioFlights: InsertionOrderFlight[] | undefined,
  ioLineItems: LineItemSchedule[],
  current: Pick<LineItemSchedule, '_id' | 'beginDate' | 'endDate' | 'name'>
) {
  const { formatMessage } = useIntl();
  const occupiedRanges = useMemo(
    () =>
      getIoFlightRanges(ioFlights ?? NO_FLIGHTS, index =>
        formatMessage(
          { defaultMessage: 'Flight {index}', id: 'spc.flightSettings.flight.defaultLabel' },
          { index: index + 1 }
        )
      ),
    [ioFlights, formatMessage]
  );
  const { _id, beginDate, endDate, name } = current;
  const markers = useMemo(
    () => getIoLineItemMarkers(ioLineItems, { _id, beginDate, endDate, name }),
    [ioLineItems, _id, beginDate, endDate, name]
  );
  return { markers, occupiedRanges };
}
